"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var WidgetIcons;
(function (WidgetIcons) {
  WidgetIcons["CardWaiting"] = "cardWaiting";
  WidgetIcons["CardIncoming"] = "cardIncoming";
  WidgetIcons["CardSpending"] = "cardSpending";
  WidgetIcons["CardTransfer"] = "cardTransfer";
  WidgetIcons["CardPay"] = "cardPay";
  WidgetIcons["Transfer"] = "transfer";
  WidgetIcons["RubRotate"] = "rubRotate";
  WidgetIcons["Rotate"] = "rotate";
  WidgetIcons["Percent"] = "percent";
  WidgetIcons["Attention"] = "attention";
  WidgetIcons["Protection"] = "protection";
  WidgetIcons["Challenge"] = "challenge";
  WidgetIcons["Briefcase"] = "briefcase";
  WidgetIcons["Orders"] = "orders";
  WidgetIcons["Wallet"] = "wallet";
  WidgetIcons["Clock"] = "clock";
  WidgetIcons["Plane"] = "plane";
  WidgetIcons["Purse"] = "purse";
  WidgetIcons["Flashlight"] = "flashlight";
  WidgetIcons["Profile"] = "profile";
  WidgetIcons["Calendar"] = "calendar";
  WidgetIcons["CardPercent"] = "cardPercent";
  WidgetIcons["Circulation"] = "circulation";
})(WidgetIcons || (WidgetIcons = {}));
var _default = WidgetIcons;
exports.default = _default;